import type { NavItem } from '@/app/nav/collect'

/**
 * The shell already declares every documents entry (`src/modules/shell/nav.ts`: the employer "Documents" link —
 * document templates were dropped 2026-10-27, document groups 2026-10-28; `/ca/documents`; `/em/documents`) — nothing
 * to add.
 */
const nav: NavItem[] = []

export default nav
